export enum ConstLocalStorage {
  token = "token",
  user = "user",
  language = "language"
}
